import React, { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Plus, Trash2, Star } from 'lucide-react';
import { toast } from 'sonner';

const EMPTY = { name: '', location: '', message: '', rating: 5, avatar: '' };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const load = useCallback(async () => {
    const { data } = await api.get('/testimonials');
    setItems(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try {
      await api.post('/testimonials', { ...form, rating: Number(form.rating) });
      toast.success('Testimonio agregado');
      setDialog(false);
      setForm(EMPTY);
      load();
    } catch { toast.error('Error al guardar'); }
  };

  const remove = async (id) => {
    if (!window.confirm('¿Eliminar?')) return;
    await api.delete(`/testimonials/${id}`);
    load();
  };

  return (
    <div data-testid="admin-testimonials-page">
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <div>
          <h1 className="font-display text-3xl text-slate-900">Opiniones</h1>
          <p className="text-slate-500 text-sm">{items.length} testimonios publicados</p>
        </div>
        <Button onClick={() => setDialog(true)} className="rounded-full btn-pink" data-testid="add-testimonial-btn">
          <Plus className="h-4 w-4 mr-1" /> Nuevo
        </Button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {items.map((t) => (
          <div key={t.id} data-testid={`testimonial-row-${t.id}`} className="bg-white border border-slate-200 rounded-2xl p-5">
            <div className="flex items-center gap-1 text-amber-400 mb-2">
              {[...Array(t.rating || 5)].map((_, i) => <Star key={`star-${t.id}-${i}`} className="h-3.5 w-3.5 fill-amber-400" />)}
            </div>
            <p className="text-sm text-slate-700 italic">"{t.message}"</p>
            <div className="flex items-center justify-between mt-4 pt-3 border-t border-slate-100">
              <div>
                <p className="font-semibold text-slate-800 text-sm">{t.name}</p>
                <p className="text-xs text-slate-500">{t.location}</p>
              </div>
              <button onClick={() => remove(t.id)} className="text-rose-600 hover:bg-rose-50 h-8 w-8 rounded-lg inline-flex items-center justify-center" data-testid={`delete-testimonial-${t.id}`}>
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={dialog} onOpenChange={setDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-display text-2xl">Nuevo testimonio</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Nombre</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-xl" /></div>
            <div><Label>Ubicación</Label><Input value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} className="rounded-xl" /></div>
            <div><Label>Mensaje</Label><Textarea rows={3} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="rounded-xl" /></div>
            <div><Label>Rating (1-5)</Label><Input type="number" min={1} max={5} value={form.rating} onChange={(e) => setForm({ ...form, rating: e.target.value })} className="rounded-xl" /></div>
            <div><Label>URL avatar (opcional)</Label><Input value={form.avatar} onChange={(e) => setForm({ ...form, avatar: e.target.value })} className="rounded-xl" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setDialog(false)}>Cancelar</Button>
            <Button onClick={save} disabled={!form.name || !form.message} className="rounded-full btn-pink">Guardar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
